import { jsx as _jsx } from "react/jsx-runtime";
import { FileExtensionPreview, ImageContainer } from "@air/component-file-extension-preview";
import classNames from "classnames";
import { memo } from "react";
import { SHARED_PANEL_ITEM_THUMBNAIL_CLASS_NAMES } from "../../constants/ClassNames";
import { FileStatusFolderStatus } from "./FileStatusFolderStatus";
export const FileStatusThumbnail = /*#__PURE__*/ memo((param)=>{
    let { ext = "", status, thumbnailSource } = param;
    return thumbnailSource ? /*#__PURE__*/ _jsx("img", {
        className: "mr-3 inline-block size-10 shrink-0 rounded-2 object-cover",
        src: thumbnailSource,
        alt: ""
    }) : ext === "folder" ? /*#__PURE__*/ _jsx(FileStatusFolderStatus, {
        status: status
    }) : /*#__PURE__*/ _jsx(ImageContainer, {
        ext: ext,
        processing: false,
        borderRadius: 2,
        className: classNames(SHARED_PANEL_ITEM_THUMBNAIL_CLASS_NAMES, "!grow-0 rounded-2"),
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex h-full items-center justify-center",
            children: /*#__PURE__*/ _jsx(FileExtensionPreview, {
                ext: ext,
                size: "small",
                className: "max-w-[40px]"
            })
        })
    });
});
FileStatusThumbnail.displayName = "FileStatusThumbnail";
